import { Button } from '@placer-ui/components';
import React, { FC, useCallback } from 'react';
import { ScreenshotStatus } from '../../../../../infra';
import { IConversationRun } from '../../../model/ConversationRun';
import { useAssistantFacade } from '../../hooks/useAssistantFacade';
import { useUiManager } from '../../hooks/useUiManager';

export const ScreenshotRequestAction: FC<{ run: IConversationRun }> = (props) => {
    const { run } = props;
    const facade = useAssistantFacade();
    const conversationId = run.conversationId.get();
    const uiManager = useUiManager();

    const handleTakeScreenshot = useCallback(async () => {
        const screenshotResult = await uiManager.capturePIScreenshot();

        const { status, image } = screenshotResult;

        if (status === ScreenshotStatus.SUCCESS && image) {
            facade.postUserMessage(conversationId, '', image);
        }
    }, [facade, uiManager, conversationId]);

    return (
        <div data-testid='screenshot-request-actions'>
            <Button onClick={handleTakeScreenshot} testId={'screenshot-request-button'}>
                Take a screenshot
            </Button>
        </div>
    );
};
